import { NgModule } from '@angular/core';

import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { EnvironmentStore } from "../core/store/environment.store";


@NgModule({
  declarations: [],
  imports: [
    RecaptchaV3Module
  ],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory: (environmentStore: EnvironmentStore) => {
        return environmentStore.recaptcha.siteKey
      },
      deps: [EnvironmentStore]
    }
  ]
})
export class RecaptchAnalyticsModule { }
